export {default as da_dk} from './da_DK';
export {default as en_us} from './en_US';
export {default as sv_se} from './sv_SE';
export {default as nb_no} from './nb_NO';
